import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = {
  class: "col-12 col-lg-3",
  "data-aos": "fade-right",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_3 = {
  class: "col-12 col-lg-9 align-items-center center-highlight-item bg-white p-4 rounded",
  "data-aos": "fade-up",
  "data-aos-offset": "300",
  "data-aos-delay": "150"
}
const _hoisted_4 = { class: "text-start text-secondary" }
const _hoisted_5 = { class: "col p-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-start text-primary"
}
const _hoisted_7 = {
  key: 1,
  class: "text-start text-primary"
}
const _hoisted_8 = {
  key: 2,
  class: "text-start text-primary"
}
const _hoisted_9 = { class: "text-start text-secondary" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_11 = { class: "text-start text-secondary" }
const _hoisted_12 = {
  key: 3,
  class: "text-start"
}
const _hoisted_13 = {
  key: 4,
  class: "text-start"
}
const _hoisted_14 = {
  key: 5,
  class: "text-start"
}
const _hoisted_15 = {
  key: 6,
  class: "text-start"
}
const _hoisted_16 = {
  key: 7,
  class: "text-start"
}
const _hoisted_17 = {
  key: 8,
  class: "text-start"
}
const _hoisted_18 = {
  key: 9,
  class: "text-start"
}
const _hoisted_19 = {
  key: 10,
  class: "text-start"
}
const _hoisted_20 = {
  key: 11,
  class: "text-start"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryItem = _resolveComponent("CategoryItem")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PRCarouselV3 = _resolveComponent("PRCarouselV3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CategoryItem)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/product" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_4, " < < " + _toDisplayString(_ctx.store.getters.localized('allProduct')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_PRCarouselV3, {
        image: _ctx.doc.images
      }, null, 8, ["image"]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.store.state.language==='th')
          ? (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.doc.nameTH), 1))
          : (_ctx.store.state.language==='ch')
            ? (_openBlock(), _createElementBlock("h4", _hoisted_7, _toDisplayString(_ctx.doc.nameCH), 1))
            : (_openBlock(), _createElementBlock("h4", _hoisted_8, _toDisplayString(_ctx.doc.nameEN), 1)),
        _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.store.getters.localized('codeProduct')) + " : " + _toDisplayString(_ctx.doc.code), 1),
        _hoisted_10,
        _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.store.getters.localized('detail')), 1),
        (_ctx.store.state.language==='th')
          ? (_openBlock(), _createElementBlock("h6", _hoisted_12, _toDisplayString(_ctx.store.getters.localized('temple')) + " : " + _toDisplayString(_ctx.doc.templeNameTH), 1))
          : (_ctx.store.state.language==='ch')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_13, _toDisplayString(_ctx.store.getters.localized('temple')) + " : " + _toDisplayString(_ctx.doc.templeNameCH), 1))
            : (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(_ctx.store.getters.localized('temple')) + " : " + _toDisplayString(_ctx.doc.templeNameEN), 1)),
        (_ctx.store.state.language==='th')
          ? (_openBlock(), _createElementBlock("h6", _hoisted_15, _toDisplayString(_ctx.store.getters.localized('region')) + " : " + _toDisplayString(_ctx.doc.regionTH), 1))
          : (_ctx.store.state.language==='ch')
            ? (_openBlock(), _createElementBlock("h6", _hoisted_16, _toDisplayString(_ctx.store.getters.localized('region')) + " : " + _toDisplayString(_ctx.doc.regionCH), 1))
            : (_openBlock(), _createElementBlock("h6", _hoisted_17, _toDisplayString(_ctx.store.getters.localized('region')) + " : " + _toDisplayString(_ctx.doc.regionEN), 1)),
        (_ctx.store.state.language==='th')
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.doc.descriptionTH), 1))
          : (_ctx.store.state.language==='ch')
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.doc.descriptionCH), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.doc.descriptionEN), 1))
      ])
    ])
  ]))
}